import { Button, Result } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

export function AvailableBlocksLoadFailed({
  onRetry
}: {
  onRetry: () => void
}) {
  const { t } = useTranslation()

  return (
    <Result
      status="error"
      title={t("documentTemplates.blocksLoadFailed")}
      extra={<Button onClick={onRetry}>{t("common.retry")}</Button>}
    />
  )
}
